import { render, staticRenderFns } from "./crm-watch-show.vue?vue&type=template&id=2e24c871&"
import script from "./crm-watch-show.vue?vue&type=script&lang=js&"
export * from "./crm-watch-show.vue?vue&type=script&lang=js&"
import style0 from "./crm-watch-show.vue?vue&type=style&index=0&id=2e24c871&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports